import { OrderManagementPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const orderFulfillmentAnalyticsRoutes: PermissionedRouteObject[] = [
  {
    index: true,
    handle: { permission: OrderManagementPermissions.RECEIVE_ORDER_UPDATES },
    async lazy() {
      const { OrderFulfillmentAnalyticsPage } =
        await import("./order-fulfillment-analytics-page");
      return { Component: OrderFulfillmentAnalyticsPage };
    },
  },
];
